/**
 * AUTHOR: DEEPAK KB
 * This is a generic component to display list in company module.
 * This component takes ListModel as a single object and shows a single row of data.
 * You have to for loop this component in parent's html to show multiple list.
 * This is a primitive list which only shows 1 row based of @Input ListModel type.
 * Its emits multiple events based of user clicks on checkbox, details, status and option.
 * The whole component is divided into 5 section and all are optional, whichever data is sent as null will not be shown.
 * Checkbox, Profile pic, Details, status and options are the 5 sections.
 */

import { Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, ViewChild } from "@angular/core";
import { ColorCode } from "../../Company.enum";
import { ListModel } from "../../companie.model";
import { DisplayType, Roles } from "src/app/utils"
import { FormGroup, FormBuilder } from '@angular/forms'
import { RolebasedactionService } from 'src/app/services/rolebasedaction.service';

@Component({
  standalone: false,
  selector: 'list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ListComponent implements OnInit, OnChanges {
  @Input()
  list;
  @Input()
  companylist;
  @Output()
  selectedOption = new EventEmitter<ListModel>();
  @Output()
  selectedCheckBox = new EventEmitter<any>();
  @Output()
  selectedStatus = new EventEmitter<any>();
  @Output()
  showSelectedItem = new EventEmitter<ListModel>();
  openOptionDrawer: boolean = false;
  @Input() displayType: number = 1;
  Roles = Roles;
  DisplayType = DisplayType;
  defaultUserImage = 'assets/images/DefaultUserImg.png'
  verified_user = 'assets/images/company/verified_user.png'
  archived_user = 'assets/images/company/archive_user.png'
  not_verfied_user = 'assets/images/company/verified_user_pending.png'
  bloacked_user = 'assets/images/company/blocked_user.png'
  form: FormGroup
  @Input() checked: boolean = false;
  @Output()
  markUser = new EventEmitter<any>();
  @Output()
  removeUser = new EventEmitter<any>();
  @Output()
  updateCompany = new EventEmitter<any>()
  @Output()
  redirectToEditPage = new EventEmitter<any>()
  @ViewChild('dotDropdown', { static: false }) dotDropdown: ElementRef;
  @Output()
  dotClicked = new EventEmitter<any>()
  @Input() checkPopupFlag
  companyAdd: any;
  constructor(private rolebasedactionService: RolebasedactionService) {

    //Comment the below code once integrated with actual data.
    this.list = {
      checkbox: false,
      listId: null,
      details: {
        name: "Deepak",
        role: 'Admin',
        roleColor: ColorCode.ROLE_TITLE,
        title1: 'Creator',
        title2: 'Adventurer'
      },
      image: {
        profilePic: '/assets/images/avatar.png',
        badge: '/assets/images/avatar.png'
      },
      status: {
        title: 'Revoke VMS invitation rights',
        color: ColorCode.REVOKE_RIGHTS
      },
      option: [
        {
          title: 'Give VMS Invitation Rights',
          id: 0
        },
        {
          title: 'Verify',
          id: 1
        },
        {
          title: 'De-activate',
          id: 2
        },
        {
          title: 'Block',
          id: 3
        }
      ]
    }
  }

  ngOnChanges() {
    console.log(this.checkPopupFlag);
    console.log(this.list);
    this.openOptionDrawer = false
    // if (this.checkPopupFlag != undefined && this.checkPopupFlag.tenantName != undefined && this.checkPopupFlag.tenantName == this.list.tenantName) {
    //   this.openOptionDrawer = true;
    //   console.log('here');
    // }
    if (this.checkPopupFlag != undefined && this.checkPopupFlag.tenantId != undefined && this.checkPopupFlag.tenantId == this.list.tenantId) {
      this.openOptionDrawer = true;
      console.log('here');
    }
    else if (this.checkPopupFlag != undefined && this.checkPopupFlag.userId != undefined && this.checkPopupFlag.userId == this.list.userId) {
      this.openOptionDrawer = true
      console.log('here 2');
      console.log(this.list.userId);
      console.log(this.checkPopupFlag.userId);
    }
  }

  ngOnInit() { 
    this.companyAdd = this.rolebasedactionService.checkUserRolePermissionExits('Company:Create');
  }

  @HostListener('click', ['$event'])
  captureClick(event) {
    if (event.target.className !== 'drawer-container') {
      this.openOptionDrawer = false;
    }
  }

  markUserStatus(user, role) {
    this.markUser.emit({ id: user.userId, role: role });
  }

  markCompStatus(comp, type) {
    this.updateCompany.emit({ id: comp.tenantId, type: type });
  }

  removeUserStatus(user, role) {
    this.removeUser.emit({ id: user.userId, role: role });
  }


  selectedCheckBoxItem(item, employeeRole) {
    this.checked = !this.checked
    this.selectedCheckBox.emit({ id: item, checked: this.checked, employeeRole: employeeRole });
  }

  selectedStatusUpdate(item: ListModel, type) {
    this.selectedStatus.emit({ item: item, type: type });
  }

  drawerOptionSelectHandler(item: ListModel) {
    this.openOptionDrawer = false;
    this.selectedOption.emit(item);
  }

  showDetailsHandler(item) {
    this.showSelectedItem.emit(item);
  }

  redirectToEdit(tenantId) {
    this.redirectToEditPage.emit(tenantId);
  }

  chechPopup(list) {
    this.dotClicked.emit(list);
  }
}
